module.exports = __webpack_public_path__ + "img/658.da3de329.jpg";